<script>
	import { onMount } from 'svelte';
	import {updtCompany,addCompany,getAllCompany, getCompanyData, joinCompany} from "../../../../api/Company";
	import {cancelRequest} from "../../../../api/cancelRequest";
	import { productImg } from '../../../../stores.js';

	/*
		Company name by default is set to 'none'
		The user must add or join a company 
		The first user to create the account is set as admin of the organization
	*/

	let companyImg = null;
	let fileInput = null;
	var companyName = null; 
	var user = null;
	var company = null;
	var companyList = null;
	var requests = null;
	const ProductsList = Object.keys(productImg);
	export let colaboratorsList = null;
	

	var companyInfo = {

		CompanyName: null,
		Country: 'Select',
		Address1: null,
		City: null,
		Products:null,
		Picture: null
	}

	var dataReady = false;

	onMount(async() =>{

		user = localStorage.getItem('user');
		user =  JSON.parse(user);
		companyName = user.company;


		if(user.requests){

			requests = user.requests;
		}

		if(companyName != 'none'){

			var res = await getCompanyData({companyName: companyName});

			if(res.status == 'valid'){

				company = res.company;
				localStorage.setItem('company', JSON.stringify(company));
				colaboratorsList = company.Colaborators;
				if(company.Picture){
					companyImg = company.Picture;
				}


			}
			else if(res.status == 'error'){
				await handleSystemErrors(res.err);
			}

		}

	});

	/*
		companyState

		0 - default State
		1 - Add company State
		2 - Join company State

	*/
	let companyState = 0;

	// handles the company info update data
	let updateCompany = false;

	function editHandle(){

		if(user.role == 'admin'){
			updateCompany = !updateCompany;

			if(updateCompany){

				for (const [key, value] of Object.entries(company)) {

					companyInfo[key] = value;
				}
			}
			else{
				dataReady = false;
			}	
		}
		
	}

	async function companyStateHandler(e){

		var id = e.target.id;

		companyState = id;

		if(companyState == 2 && companyList == null ){

			var res = await getAllCompany();

			if(res.status == 'valid'){

				companyList = res.companyNameList;
			}
			else if(res.status == 'error'){
				// handle error;
				//failed to get company data
			}

		}
	}

	function addNewProduct(e){

		var productEl = document.getElementById('Products');

		var productName = productEl.value;

		if(productName != ''){
			var product = {};

			product.name = productName;

			if(companyInfo.Products == null){
				companyInfo.Products = [];
			}
			

			companyInfo.Products.push(product);

			companyInfo.Products = companyInfo.Products;

			productEl.value = '';
			productEl.style.border = '1px solid white';	
			productEl.style.borderRadius = '3px';
		}
		else{
			productEl.style.border = '1px solid red';

			productEl.placeholder = 'Add a product name' 
		}

	}

	function removeProduct(e){

		var id = e.target.id;
		
		companyInfo.Products.splice(id, 1);

		companyInfo.Products = companyInfo.Products;
	}

	// adds the Country products to the company info product list
	// the user can delete the ones the company doesn't produce
	function countrySelected(){

		// companyInfo.Products 
		companyInfo.Products = [];
		var country = companyInfo.Country;

		var countryProducts = productImg[country];

		for (const [key, value] of Object.entries(countryProducts)){

					if(key == 'partners'){

					}
					else{
						var product = {};

						product.name = countryProducts[key].name ;
						product.nutritionalInfo = {};

						if(companyInfo.Products == null){
							companyInfo.Products = [];
						}
						

						companyInfo.Products.push(product);

						companyInfo.Products = companyInfo.Products;
					}
		}
	}

	function saveData(){

		var allInputsValid = 0;
		


		for (const [key, value] of Object.entries(companyInfo)) {
		  	
		  	if((value == null || value == 'Select') && key != 'Picture'){
		  		
		  		//alert user - field must be filled
		  		var el = document.getElementById(key);
		  		el.style.border = "1px solid red";
		  		el.placeholder = 'enter a value';

		  	}
		  	else{
		  		// add aditional checking for value type
		  		allInputsValid++;
		  	}
		}

		if(allInputsValid == Object.keys(companyInfo).length){
			
			dataReady = true;
			
		}
	}

	async function submitData(){

		//Send Data to Db

		//check if company already exists

		//if company exists - warn user to join company or change company name

		var finalData = {
			userEmail: user.email,
			companyInfo: companyInfo
		}

		// provisory code

		// if(companyImg != null){

		// 	// saveImage(companyImg);

		// }

		if(companyName != 'none'){

			var res = await updtCompany(finalData);



			if(res.status == 'valid'){

				// localStorage.setItem('user', JSON.stringify(res.user));
				// alert('Updated with success');

				updateCompany = false;
				dataReady = false;
				window.location.reload();

			}
			else if(res.status == 'error'){
				alert('error updating company data');
			}



		}
		else{
			var res = await addCompany(finalData);

			if(res.status == 'valid'){

				localStorage.setItem('user', JSON.stringify(res.user));
				window.location.reload();
			}
			else if(res.status == 'error'){

				//show user error message
			}
		}
	}


	async function handleJoinCompany(){

		var selectEl = document.getElementById('joinCompanySelect');

		if(selectEl.value != '' || selectEl.value != null){
			var data = {};
			data.userEmail = user.email;
			data.companyName = selectEl.value;

			var res = await joinCompany(data);

			if(res.status == 'valid'){

				//valid request wait for admin aproval
				localStorage.setItem('user', JSON.stringify(res.user));
				window.location.reload();

			}
			else if(res.status == 'error'){
				//request failed
			}


		}
		else{

			//user must select a company to join
		}

	}

	/*
		This function will handle the cancelation of the Request in two states
		
		pending - The user canceled the request before the organization admin,
				  acepted or denied the join request.

		denied - The request was denied and the user deletes the request message

	*/
	async function cancelRequestHandler(e){

		var cancelState = e.target.id;
		var companyName = e.target.getAttribute('name');


		var data ={
			Status: cancelState,
			CompanyName: companyName,
			Email: user.email
		}


		var res = await cancelRequest(data);

		if(res.status == 'valid'){

			// alert('valid');
			localStorage.setItem('user', JSON.stringify(res.user));
			window.location.reload();

		}
		else if(res.status == 'error'){
			alert('error');

		}
	}


	function onFileSelected(e){

	  let image = e.target.files[0];
	            let reader = new FileReader();
	            reader.readAsDataURL(image);
	            reader.onload = e => {
	                 companyImg = e.target.result;
	                 companyInfo.Picture = companyImg;
	            };

	}


</script>



<div class="companyInfoContainer">

	{#if companyName == 'none'} <!-- User doesnt have company yet -->

		
		{#if companyState == 0 } <!-- Default state ADD or JOIN -->

			<div class="companyOptionsContainer imageBackGround">

				<div class="welcomeMessageContainer">
					<div class="welcomeMessage">
						Welcome to<div class="logoColor">&nbsp;ArtiSaneFood&nbsp;</div>{user.firstName + ' ' + user.lastName}! 
					</div>

					<div class="welcomeMessage">
						Add or join an organization to get started.
					</div>	
				</div>

				<div class="actionsContainer">

					<div class="actionBtnContainer">
						
						{#if requests == null }

							<div class="actionBtn" id="1" on:click={(e)=> companyStateHandler(e)}>
								Add
							</div>

							<div class="actionBtn" id="2" on:click={(e)=> companyStateHandler(e)}>
								Join
							</div>

						{:else}

							{#if requests.length > 0}

								{#if requests[0].status == 'pending'}
									<div class="inactiveActionBtn" id="1" >
										Add
									</div>

									<div class="inactiveActionBtn" id="2" >
										Join
									</div>
								{:else}
									<div class="actionBtn" id="1" on:click={(e)=> companyStateHandler(e)}>
										Add
									</div>

									<div class="actionBtn" id="2" on:click={(e)=> companyStateHandler(e)}>
										Join
									</div>
								{/if}
								
							{:else}
								<div class="actionBtn" id="1" on:click={(e)=> companyStateHandler(e)}>
									Add
								</div>

								<div class="actionBtn" id="2" on:click={(e)=> companyStateHandler(e)}>
									Join
								</div>
							{/if}
							

						{/if}
						

					</div>
						
				</div>
			</div>

			<div class="companyOptionsContainer">
				
				<div class="requestContainer">
					
						{#if requests != null}
							{#each requests as request,index}

								{#if request.status == 'pending'}
									<div class="requestMsgContainer">
										<div class="requestMsg" >
											Your request to join {request.companyName} is pending admin aproval. 
										</div>
										<div class="cancelRequest" id={request.status} name={request.companyName} on:click={(e) => cancelRequestHandler(e)}> 
											Cancel
										</div>
									</div>
								{:else if request.status == 'denied'}
									<div class="requestMsgContainer">
										<div class="requestMsg">
											Your request to join {request.companyName} was denied. 
										</div>
										<div class="cancelRequest" id={request.status} name={request.companyName} on:click={(e) => cancelRequestHandler(e)}>
											Cancel
										</div>
									</div>
								{:else}

								{/if}
							{/each}
						{/if}
						

				</div>
			</div>
		{:else if companyState == 1} <!-- ADD company -->

			<div class="companyAddContainer noCompany">


				<div class="topContainer ">

					<div class="goBackBtnContainer">
						

						<div class="dataHandleBtn cancelBtn" id="0" on:click={(e)=> companyStateHandler(e)}>
							Cancel
						</div>

						{#if dataReady}
							<div class="dataHandleBtn inactiveBtn">
								Save
							</div>

							<div class="dataHandleBtn activeBtn" on:click={() => submitData()}>
								Submit
							</div>
						{:else}
							<div class="dataHandleBtn activeBtn" on:click={() => saveData()}>
								Save
							</div>

							<div class="dataHandleBtn inactiveBtn">
								Submit
							</div>
						{/if}
							
					</div>
					
				</div>

				<div class="formContainer">

					<div class="companyAddColumn">
						

						{#if companyImg}
							<img class="avatar" src={companyImg} on:click={()=>{fileInput.click();}} alt="d" />

							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>

						{:else}

							<div class="imgUpload" on:click={()=>{fileInput.click();}}>Upload logo</div>
							
							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>


						{/if}

					</div>

					<div class="companyAddColumn">
						<label class="formLabel" for="Company_Name">Company Name</label>
						<input bind:value={companyInfo.CompanyName} class="formInput" type="text" name="Company Name" id="CompanyName" placeholder="Enter a value">

						<label class="formLabel" for="Product">Address 1</label>
						<input bind:value={companyInfo.Address1} class="formInput" type="text" name="Address 1" id="Address1" 
						placeholder="Enter a value">
						
					</div>

					<div class="companyAddColumn">
						<label class="formLabel" for="Country">Country</label>
						<select bind:value={companyInfo.Country} on:change={() => countrySelected()} class="formInput formSelect minimal" type="text" name="Country" id="Country" placeholder="Enter a value">

							<option class="formInputOption" value="Select">Select</option>
							{#if ProductsList != null}
								{#each ProductsList as product}
									 <option class="formInputOption" value={product}>{product}</option>
								{/each}
							{/if}
						</select>
						

						<label class="formLabel" for="City">City</label>
						<input bind:value={companyInfo.City} class="formInput" type="text" name="City" id="City" placeholder="Enter a value">

						

						{#if companyInfo.Products!= null}
							<label class="formLabel productsMessage" for="Product">Your country products: </label>
							{#each companyInfo.Products as product,index}

								<div class="addProductsContainer">
									<div class="addProductInput centerProductText ">{product.name}</div>
									<div class="addProductBtn removeProductBtn" id={index} on:click={(e) => removeProduct(e)}>
										<i class="fa-solid fa-circle-plus"></i>
									</div>
								</div>
							
							{/each}
						{/if}
	
					</div>

				</div>				
				
			</div>
		{:else if companyState == 2} <!-- JOIN company -->
			<div class="companyAddContainer noCompany">


				<div class="topContainer ">

					<div class="goBackBtnContainer">
					
						<div class="dataHandleBtn cancelBtn" id="0" on:click={(e)=> companyStateHandler(e)}>
							Cancel
						</div>
							
					</div>
					
				</div>

				<div class="formContainer">

					<div class="companyJoinColumn">
						<label class="formLabel" for="Company_Name">Company Name</label>
						
						<select value="" class="formInput formSelect" name="Company Name" id="joinCompanySelect">
							{#if companyList != null}
								{#each companyList as company,index}
									 <option class="formInputOption" value={company.name}>{company.name}</option>
								{/each}
							{/if}
						</select>
			
					</div>

					<div class="companyJoinColumn">

						<label class="formLabel" for="Company_Name"></label>
						<div class="joinBtn" on:click={() => handleJoinCompany() } >Join Company</div>	

					</div>
				</div>				
				
			</div>
		{:else}
		{/if}

	{:else} <!-- User has company -->

		
		<div class="companyAddContainer">


			<div class="topContainer ">

				<div class="goBackBtnContainer">
					

					{#if updateCompany}
						<div class="dataHandleBtn cancelBtn" on:click={() => editHandle()}>
							Cancel
						</div>
						
						

						{#if dataReady}
							<div class="dataHandleBtn inactiveBtn">
								Save
							</div>
							
							<div class="dataHandleBtn activeBtn" on:click={() => submitData()}>
								Submit
							</div>
						{:else}

							<div class="dataHandleBtn activeBtn" on:click={() => saveData()}>
								Save
							</div>

							<div class="dataHandleBtn inactiveBtn">
								Submit
							</div>
						{/if}
						


					{:else}
						<div class="dataHandleBtn activeBtn" on:click={() => editHandle()}>
							Edit
						</div>
						
						<div class="dataHandleBtn inactiveBtn">
							Save
						</div>

					
						<div class="dataHandleBtn inactiveBtn">
							Submit
						</div>
					{/if}
					
					
						
				</div>
	
			</div>

			<div class="formContainer">


				{#if updateCompany}

					<div class="companyAddColumn">
					

						{#if companyImg}
							<img class="avatar" src={companyImg} on:click={()=>{fileInput.click();}} alt="d" />

							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>

						{:else}


							<!-- <div class="imgUpload" on:click={() => uploadCompanyImg()}>Upload logo</div> -->

							<div class="imgUpload" on:click={()=>{fileInput.click();}}>Upload logo</div>
							
							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>


						{/if}
						
					</div>

					{#if company != null}

						<div class="companyAddColumn">
							<label class="formLabel" for="Company_Name">Company Name</label>
							<input bind:value={companyInfo.CompanyName} class="formInput" type="text" name="Company Name" id="CompanyName" placeholder="" disabled>

							<label class="formLabel" for="Product">Address 1</label>
							<input bind:value={companyInfo.Address1} class="formInput" type="text" name="Address 1" id="Address1" placeholder="" >

						</div>

						<div class="companyAddColumn">
							<label class="formLabel" for="Country">Country</label>
							<select bind:value={companyInfo.Country} on:change={() => countrySelected()} class="formInput formSelect minimal" type="text" name="Country" id="Country" placeholder="" disabled>
								{#if ProductsList != null}
									{#each ProductsList as product}
										 <option class="formInputOption" value={product}>{product}</option>
									{/each}
								{/if}
							</select>

							<label class="formLabel" for="City">City</label>
							<input bind:value={companyInfo.City} class="formInput" type="text" name="City" id="City" placeholder="">
						
						</div>
					{/if}


				{:else}
					<div class="companyAddColumn">
					

						{#if companyImg}
							<img class="avatar" src={companyImg} on:click={()=>{fileInput.click();}} alt="d" />

							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>

						{:else}


							<!-- <div class="imgUpload" on:click={() => uploadCompanyImg()}>Upload logo</div> -->

							<div class="imgUpload" on:click={()=>{fileInput.click();}}>Upload logo</div>
							
							<input 
								style="display:none" 
								type="file" 
								accept=".jpg, .jpeg, .png" 
								on:change={(e)=>onFileSelected(e)} 
								bind:this={fileInput}
							>


						{/if}
						

					</div>

					{#if company != null}

						<div class="companyAddColumn">
							<label class="formLabel" for="Company_Name">Company Name</label>
							<input bind:value={company.CompanyName} class="formInput" type="text" name="Company Name" id="CompanyName" placeholder="" disabled>

							<label class="formLabel" for="Product">Address 1</label>
							<input bind:value={company.Address1} class="formInput" type="text" name="Address 1" id="Address1" placeholder="" disabled>
						</div>

						<div class="companyAddColumn">
							<label class="formLabel" for="Country">Country</label>
							<input bind:value={company.Country} class="formInput" type="text" name="Country" id="Country" placeholder="" disabled>

							<label class="formLabel" for="City">City</label>
							<input bind:value={company.City} class="formInput" type="text" name="City" id="City" placeholder="" disabled>
						
						</div>
					{/if}

				{/if}
				
			</div>				
			
		</div>
	{/if}

	
</div>


<style>


.companyInfoContainer{
	width: 100%;
	height: 100%;
	/*background-color: orangered;*/
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.companyOptionsContainer{
	width: 90%;
	height: 45%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	border-radius: 3px;
}

.companyOptionsContainer:nth-child(2){
	/*background-color: white;*/
}

.imageBackGround{
	/*width: 100% !important;
	margin-top: 0% !important;*/
	/*border-radius: 0%;*/
	background-image: url('/img/mediterranean_img/cheeseRow.jpg');
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.requestContainer{
	width: 100%;
	height: 100% ;
	/*background-color: red;*/
	margin-top: 5%;
}

.requestMsgContainer{
	width: 50%;
	height: 5.54016620498615vh;
	border: 1px solid white;
	border-radius: 3px;
	background-color: transparent;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: center;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.requestMsg{
	width: 80%;
	height: 100%;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
}

.cancelRequest{
	width: 20%;
	height: 100%;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	color: black;
	opacity: 0.5;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.cancelRequest:hover{
	color: red;
	opacity: 1;
}



.logoColor{
	color: #FFAE6A;
}

.welcomeMessageContainer{
	width: 100%;
	height: 30%;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	/*background-color: red;*/
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10%;
}
.welcomeMessage{
	
	width: 95%;
	height: fit-content;
	font-size: 26px;
	font-weight: 700;
	color:  white;
	display: flex;
	flex-direction: row;
	/*background-color: yellow;*/
}

.actionsContainer{
	width: 100%;
	height: 70%;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	/*background-color: red;*/
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	/*align-items: flex-end;*/
	gap: 10%;
}

.actionBtnContainer{
	width: 95%;
	height: 40%;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	/*background-color: orange;*/
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 10%;

}

.actionBtn{
	width: 10.88%;
	height: 46.99%;
	background-color: transparent;
	border: 1px white solid;
	border-radius: 3px;
	color: white;
	font-size: 1.0416666666666667vw;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.actionBtn:hover{

}

.inactiveActionBtn{
	width: 10.88%;
	height: 46.99%;
	background-color: transparent;
	border: 1px white solid;
	border-radius: 3px;
	color: white;
	font-size: 1.0416666666666667vw;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0.2;
}

.companyAddContainer{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: flex-start;
	/*background-color: orange;*/
}

.noCompany{
	width: 76.47% !important;
	align-self: flex-start !important;

}

.topContainer{
	width: 100%;
	height: 6%;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-end;
	border-radius: 0px;
	margin-top: 3%;
}
.goBackBtnContainer{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: flex-end;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	margin-top: 0.4%;
}

/*.goBackBtn{
	width: 10%;
	height: 100%;
	border: 1px black solid;
	display: flex;
	align-items: center;
	justify-content: center;
	color: black;
	border-radius: 3px;
	font-size: 0.9114583333333334vw;
}

.goBackBtn:hover{
	opacity: 1;
	font-size: 1vw;
	border: 2px #f44336 solid;
	color: #f44336;
}*/

.dataHandleBtn:nth-child(2), .dataHandleBtn:nth-child(3){
	margin-left: 2%;
}

.dataHandleBtn{
	width: 10%;
	height: 100%;
	border: 1px rgba(255, 255, 255, 0.5) solid;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--brand-accent);
	border-radius: 3px;
	font-size: 0.9114583333333334vw;
	cursor: pointer;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}


.cancelBtn{
	color:  red;
}

.cancelBtn:hover{
	box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
	transform: translateY(0px);
}

.activeBtn{
}

.activeBtn:hover{
	box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
	transform: translateY(0px);
}


.inactiveBtn{
	opacity: 0.5;
	color: black;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
}

.formContainer{
	width: 98%;
	height: 70%;
	/*background-color: orange;*/
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	margin-top: 5%;
}

.companyAddColumn{
	width: 33.33333%;
	height: 100%;
	/*background-color: red;*/
	flex-direction: column;
	gap: 2%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.companyAddColumn:nth-child(1){
	align-items: center;
}

.companyAddColumn:nth-child(2){
	align-items: flex-start;
}
.companyAddColumn:nth-child(3){
	align-items: flex-end;
}

.formLabel{
	width: 90%;
	height: 2.770083102493075vh;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	flex-shrink: 0;
	flex-grow: 0;
}

.formInput{
	width: 90%;
	height: 5.54016620498615vh;
	border: 1px solid rgba(255, 255, 255, 0.5);
	border-radius: 3px;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	/*font-weight: 700;*/
	flex-shrink: 0;
	flex-grow: 0;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}


.addProductsContainer{

	width: 90%;
	height: 5.54016620498615vh;
	display: flex;
	flex-direction: row;
	gap: 5%;

}

.productsMessage{
	color:black;
	font-size: 1.0416666666666667vw;
	font-weight: 700;
	margin-top: 5%;
	margin-bottom: 5%;
}
.addProductInput{
	width: 80%;
	height: 5.54016620498615vh;
	border: 1px solid white;
	border-radius: 3px;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.addProductBtn{
	width: 15%;
	height: 5.54016620498615vh;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
}

.addProductBtn > i{
	transform: scale(2);
}


.centerProductText{
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-wrap: nowrap;
	text-indent:0%;
	padding-left: 5%;
}

.removeProductBtn{
	transform: rotate(45deg);
}


.imgUpload{
	width:9.765625vw;
	height:20.775623268698062vh;
	/*border: 1px solid white;*/
	border-radius: 5px;
	background-color: #FFAE6A;
	display: flex;
	align-items: center;
	justify-content: center;
	color:black;
	font-size: 1.0416666666666667vw;
	font-weight: 700;
	margin-top: 1%;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.imgUpload:hover{
	box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
	transform: translateY(0px);
}

.avatar{
		display:flex;
		width:auto;
		height:20.775623268698062vh;
		max-height:20.775623268698062vh;;
}

/*Join Company*/

.companyJoinColumn{
	width: 50%;
	height: 100%;
	/*background-color: red;*/
	flex-direction: column;
	gap: 2%;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
}

.companyJoinColumn:nth-child(2){
	margin-left: 5%;
	align-items: flex-start;	
}

.joinBtn{
	width: 30%;
	height: 5.54016620498615vh;
	border: 1px solid white;
	border-radius: 3px;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.joinBtn:hover{
	box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
	transform: translateY(0px);
}


.formSelect{      
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	-webkit-appearance: auto;
	-moz-appearance: auto;
	background-color: transparent;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
}


.formInputOption{
	width: 100%;
	height: 33.333333%;
	background-color: transparent;
	border: 1px solid white;
	border-radius: 3px;
	color: #333;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
}

</style>